export const FILTER_AREA_REQUESTED = 'filter/filter_area_REQUEST_STARTED';
export const FILTER_AREA_REQUEST_DONE = 'filter/filter_area_REQUEST_DONE';
export const FILTER_AREA_ERROR = 'filter/filter_area__REQUEST_DONE';
export const FILTER_AREA_ADD_SELECTED = 'filter/filter_area_ADD_SELECTED';
export const FILTER_AREA_REMOVE_FROM_SELECTED = 'filter/filter_area_REMOVE_FROM_SELECTED';
export const FILTER_AREA_RESET = 'filter/filter_area_FILTER_AREA_RESET';
export const FILTER_AREA_COOKIE = 'filter/filter_area_COOKIE';
